function ProfileIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 34 34'>
      <path
        fill='#465364'
        d='M17 18.125a6.75 6.75 0 110-13.5 6.75 6.75 0 010 13.5zm0-11.25a4.5 4.5 0 100 9 4.5 4.5 0 000-9z'
      />
      <path
        fill='#465364'
        d='M17 33.875a16.877 16.877 0 01-13.039-6.176l-.585-.72.585-.709a16.874 16.874 0 0126.078 0l.585.709-.585.72A16.875 16.875 0 0117 33.875zM6.324 26.99a14.626 14.626 0 0021.375 0 14.623 14.623 0 00-21.375 0z'
      />
      <path
        fill='#465364'
        d='M17 33.875a16.875 16.875 0 11-.022-33.75A16.875 16.875 0 0117 33.875zm0-31.5a14.625 14.625 0 100 29.25 14.625 14.625 0 000-29.25z'
      />
      <path
        fill='#465364'
        d='M4.828 26.99s11.328 12.656 22.86 1.26l1.485-1.26S19.543 17 9.766 22.996L4.828 26.99zM17 17a5.625 5.625 0 100-11.25A5.625 5.625 0 0017 17z'
      />
    </svg>
  );
}

export default ProfileIcon;
